export default {
    apiKey: "AIzaSyDoxA50iI4v6RNTyD9XOz6Ajhp91iJoMog",
    authDomain: "mosbas.firebaseapp.com",
    databaseURL: "https://mosbas.firebaseio.com",
    projectId: "mosbas",
    storageBucket: "mosbas.appspot.com",
    messagingSenderId: "211832853502",
    appId: "1:211832853502:web:6bbcc0df8e66686e3466af",
    measurementId: "G-PP6MWS0SJC"
}
